import { render, staticRenderFns } from "./jak-kupic-japonskie-akcje.md?vue&type=template&id=14fe0308&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports